import { useChatSession } from "../context/ChatSessionProvider";

/**
 * A fresh chat with nothing sent yet is the "home" state: the masthead is
 * shown and the prompt sits with it in the middle of the page rather than
 * docked to the bottom. Shared by the layout and the message list so both
 * flip at the same instant.
 */
export const useIsChatHome = () => {
  const { sessionId, traceTurns, isStreaming } = useChatSession();
  return !sessionId && traceTurns.length === 0 && !isStreaming;
};
